import styled, { keyframes, css } from 'styled-components';

import { media } from './media-templates';

/// Card
export const CardContainer = styled.form`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  align-items: center;
  width: 50rem;
  min-height: 33.333rem;
  border-radius: 5px;
  box-shadow: 0 4rem 5rem -2rem rgba(0, 0, 0, 0.42);
  ${media.tablet`
    width: auto;
  `}
  ${media.phone`
    width: 100%;
    min-width: 300px;
    max-width: 300px;
    min-height: 340px;
    margin: 0 auto;
  `}
`;

export const CardInfoContainer = styled.div`
  width: 100%;
  min-height: 377px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 15px;
  align-items: center;
  background-color: ${({ theme }) => theme.white.a10};
  border-radius: 5px 5px 0 0;
  ${media.phone`
    min-height: 319px;
    width: 100%;
  `}
`;

export const CardTitle = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  position: relative;
  width: 100%;
`;

export const ScaleContainer = styled.div`
  background-image: linear-gradient(to bottom, #616885, ${({ theme }) => theme.baseBlue.a10});
  height: 123px;
  width: 100%;
  border-radius: 0 0 4px 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  ${media.phone`
    height: auto;
    min-height: 60px;
  `}
`;

export const CardSubject = styled.section`
  /* todo: check if should use rem or px for height / width */
  max-width: 32.8rem;
  max-height: 2.333rem;
  margin: 0 auto;
  font-size: 1.666rem;
  font-weight: 300;
  line-height: 1.4rem;
  letter-spacing: 0.4px;
  text-align: center;
  color: ${({ theme }) => theme.baseBlue.a10};
  margin-top: 2rem;
  ${media.phone`
    font-size: 1.333rem;
    margin-top: 10px;
  `}
`;

export const CornerButton = styled.div`
  position: absolute;
  left: 15px;
  top: 10px;
  ${media.phone`
    left: 0;
    top: 0;
  `}
`;

export const ComponentRouterContainer = styled.div`
  @media screen and (min-height: 650px) {
    height: 100%;
  }

  ${media.phone`
    height: auto;
    display: flex;
    min-height: 100%;
  `}
`;

// Netlify behaviour

const slideFromRight = keyframes`
  from {
    margin-right: -600px;
  }
  to {
    margin-right: 0;
  }
`;

export const slideFromBottom = keyframes`
  from {
    transform: translateY(200%);
  }
  to {
    transform: translateY(0);
  }
`;

export const RedirectNavigation = styled.div<{
  $redirect: boolean;
  $timeForSlidingOut: number;
  $timeForSlidingIn: number;
}>(
  ({ theme, $redirect, $timeForSlidingOut, $timeForSlidingIn }) => css`
    background-color: ${$redirect ? theme.baseBlue.a10 : theme.black.a3};
    width: ${$redirect ? '100%' : '647px'};
    transition: all ease ${$timeForSlidingOut}ms;
    height: 100%;
    animation: ${slideFromRight} ${$timeForSlidingIn}ms ease-in-out;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 15px;
    font-weight: 400;
    line-height: 1.73;
    color: ${theme.white.a10};
    padding: 3rem;
    ${media.phone`
      width: 100%;
      height: fit-content;
      background-color: rgba(50, 54, 69, 0.4);
      position: absolute;
      top: ${$redirect ? '-100%' : '40%'};
      transition: all 1s ease;
      animation: ${slideFromBottom} ${$timeForSlidingIn}ms linear;
    `}
  `,
);

export const RedirectContainer = styled.div`
  height: 100%;
  width: 100%;
  background-color: ${({ theme }) => theme.baseBlue.a10};
  display: flex;
  ${media.phone`
    height: auto;
    display: block;
    min-height: 100%;
  `}
`;

export const HeaderContainer = styled.div`
  color: white;
  ${media.phone`
    font-size: 12px;
  `}
`;
